module.exports = __webpack_public_path__ + "static/img/rank_319.aa0fff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_319.png
// module id = oLT8
// module chunks = 0